import * as React from "react";
import {
  Grid,
  Switch,
  Snackbar,
  Typography,
  Box,
} from "@mui/material";
import { Alert } from "@mui/material";

// helpers
import { getHeaders } from "../utils/HeaderHelper";
import { AuthenticationContext } from "../Context";
import GeneralModal from "../modals/GeneralModal";

interface Props {
  customerId: any;
  open: boolean;
  setOpen: any;
  customerName: string;
}

const EditPermission: React.FC<Props> = (props: any) => {
  //  context import
  const authenticationSetting = React.useContext(AuthenticationContext);

  const [permissions, setPermissions] = React.useState<any>([]);
  const [error, setError] = React.useState<string>("");

  const getPermissions = () => {
    fetch(`/customer_permissions/${props.customerId}`, {
      method: "GET",
      headers: getHeaders(authenticationSetting.csrfToken),
    })
      .then((result) => result.json())
      .then((result) => {
        if (result.success == false) {
          console.log(result.error);
        } else {
          setPermissions(result.resource);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  React.useEffect(() => {
    getPermissions();
  }, [props.customerId, props.open]);

  const updatePrivilegeState = (event) => {
    const permissionId = event.target.value;
    const permitted = event.target.checked;
    fetch(`/customer_permissions/${permissionId}`, {
      method: "PUT",
      headers: getHeaders(authenticationSetting.csrfToken),
      body: JSON.stringify({
        customer_permission_control: {
          permitted: permitted,
        },
      }),
    })
      .then((result) => result.json())
      .then((result) => {
        if (!result.success) {
          setError(result.message);
        } else {
          getPermissions();
        }
      })
      .catch((error) => {
        setError(error);
      });
  };

  const closeModal = () => {
    props.setOpen(false);
  };

  return (
    <>
      <GeneralModal
        open={props.open}
        title={"Organization Permissions"}
        successCallback={undefined}
        closeCallback={closeModal}
        showContinueIcon={false}
        cancelButtonText="Close"
        width="900px"
      >
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{ paddingTop: 20 }}
        >
          
          <Grid container>
            {permissions.map((permission) => (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: "5px",
                  width: "100%",
                }}
              >
                <Switch
                  value={permission.id}
                  checked={permission.permitted}
                  onChange={updatePrivilegeState}
                  color="primary"
                />
                <Typography>{permission.permission_name}</Typography>
              </Box>
            ))}
          </Grid>
        </Grid>
      </GeneralModal>
    </>
  );
};

export default EditPermission;
